import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { DEFAULT_LANGUAGE, resolveLanguage, toI18nextCode } from './languages'

/**
 * Vite resolves this at build time, so every locales/<language>/<namespace>.json
 * becomes resources[language][namespace]. This replaced 23 namespaces × N
 * languages of hand-written imports — adding a language is now adding a
 * directory, and a namespace cannot be silently missing from one language.
 */
const localeModules = import.meta.glob('./locales/*/*.json', {
  eager: true
}) as Record<string, { default: Record<string, unknown> }>

const resources: Record<string, Record<string, Record<string, unknown>>> = {}

for (const [path, module] of Object.entries(localeModules)) {
  const match = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/)
  const directory = match?.[1]
  const namespace = match?.[2]
  if (!directory || !namespace) continue
  // The locale directory is named for the app's language code; i18next may run
  // that language under a different one (see I18NEXT_CODES in ./languages).
  const language = toI18nextCode(resolveLanguage(directory))
  resources[language] ??= {}
  resources[language][namespace] = module.default
}

const storedLanguage = resolveLanguage(
  localStorage.getItem('preferred_language')
)

// NOTE: 'sk' is not a namespace, so this defaultNS never resolves. Every
// useTranslation() call in the app passes its namespace explicitly, so nothing
// depends on it — left as-is rather than changing what unqualified lookups
// would suddenly start returning.
const defaultNS = 'sk'

i18next.use(initReactI18next).init({
  lng: toI18nextCode(storedLanguage),
  fallbackLng: toI18nextCode(DEFAULT_LANGUAGE),
  debug: true,
  resources,
  defaultNS
})

export { i18next }
export default i18next
